// Add your JS customizations here

// ---------------------------------------------------------------------------
// Road Map Through the Years — desktop hover + mobile slider
// ---------------------------------------------------------------------------

(function () {
	'use strict';

	function initRoadmapTimeline() {
		var timelines = document.querySelectorAll('.roadmap-timeline');
		if (!timelines.length) {
			return;
		}

		timelines.forEach(function (timeline) {
			var items     = Array.from(timeline.querySelectorAll('.roadmap-timeline__item'));
			var itemsWrap = timeline.querySelector('.roadmap-timeline__items');
			var btnPrev   = timeline.querySelector('.roadmap-timeline__arrow--prev');
			var btnNext   = timeline.querySelector('.roadmap-timeline__arrow--next');
			var current   = 0;

			if (!items.length) {
				return;
			}

			function activateItem(index) {
				items.forEach(function (item, i) {
					var active = (i === index);
					item.classList.toggle('roadmap-timeline__item--active', active);
					item.setAttribute('aria-pressed', active ? 'true' : 'false');
				});
				current = index;
			}

			// Desktop: activate on hover
			items.forEach(function (item, index) {
				item.addEventListener('mouseenter', function () {
					if (window.innerWidth >= 768) {
						activateItem(index);
					}
				});

				// Keyboard: Enter or Space activates the item
				item.addEventListener('keydown', function (e) {
					if (e.key === 'Enter' || e.key === ' ') {
						e.preventDefault();
						activateItem(index);
						if (window.innerWidth < 768) {
							slideTo(index);
						}
					}
				});
			});

			// Mobile: slide to a given index
			function slideTo(index) {
				index = Math.max(0, Math.min(index, items.length - 1));
				current = index;
				items.forEach(function (item) {
					item.style.transform = 'translateX(-' + (index * 100) + '%)';
				});
				if (btnPrev) { btnPrev.disabled = (index === 0); }
				if (btnNext) { btnNext.disabled = (index === items.length - 1); }
				activateItem(index);
			}

			if (btnPrev) {
				btnPrev.addEventListener('click', function () {
					if (window.innerWidth < 768) { slideTo(current - 1); }
				});
			}

			if (btnNext) {
				btnNext.addEventListener('click', function () {
					if (window.innerWidth < 768) { slideTo(current + 1); }
				});
			}

			// Touch swipe support
			var touchStartX = 0;

			itemsWrap.addEventListener('touchstart', function (e) {
				touchStartX = e.changedTouches[0].screenX;
			}, { passive: true });

			itemsWrap.addEventListener('touchend', function (e) {
				if (window.innerWidth >= 768) { return; }
				var delta = touchStartX - e.changedTouches[0].screenX;
				if (Math.abs(delta) > 50) {
					slideTo(delta > 0 ? current + 1 : current - 1);
				}
			}, { passive: true });

			// Initialise: first item active, prev disabled
			activateItem(0);
			if (btnPrev) { btnPrev.disabled = true; }
			if (btnNext && items.length <= 1) { btnNext.disabled = true; }
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initRoadmapTimeline);
	} else {
		initRoadmapTimeline();
	}
})();
